<template>
  <div class="col-12 page_content_area">
    <div class="container enterprises_content_area">
      <div class="form_title mb-5">{{ formTitle }}</div>
      <div class="white_block">
        <intern-file-upload :year-select="false" :one-file-at-time="false"
          :download-file-list="currentFileNameListGetter" @upload="upload" @download="download"
          @deleteFile="deleteFile" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import InternFileUpload from '~components/common/forms/InternFileUpload'
export default {
  name: 'InternReportFileContent',
  components: {
    InternFileUpload,
  },
  computed: {
    ...mapGetters('pages/students', [
      'currentFileNameListGetter',
      'currentStudentGetter'
    ]),
  },
  async created() {
    this.togglePageLoader(true);
    await this.getStudentByToken();
    await this.loadFileNameList();
    this.togglePageLoader(false);
  },
  data() {
    return {
      formTitle: '學生校外實習報告',
      formType: 'intern_report',
    };
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/students', [
      'getStudentByToken',
      'getFileNameList',
      'uploadInternFormFile',
      'downloadInternFormFile',
      'deleteInternFile',
    ]),
    async loadFileNameList() {
      await this.getFileNameList({
        type: this.formType,
        params: {
          enterprise_id: this.$route.params.eid,
          student_id: this.currentStudentGetter.student_pk_id,
          year: this.$route.params.year,
        },
      });
    },
    async upload(uploadFileList, year) {
      this.togglePageLoader(true);
      let form = new FormData();
      uploadFileList.forEach(file => form.append('files[]', file));
      form.append('enterprise_id', this.$route.params.eid);
      form.append('student_id', this.currentStudentGetter.student_pk_id);
      form.append('year', this.$route.params.year);
      await this.uploadInternFormFile({
        type: this.formType,
        params: form,
      });
      await this.loadFileNameList();
      this.togglePageLoader(false);
    },
    async download(form_id) {
      await this.downloadInternFormFile({
        type: this.formType,
        form_id,
      });
    },
    async deleteFile(form_id) {
      this.togglePageLoader(true);
      await this.deleteInternFile({
        type: this.formType,
        form_id,
      });
      await this.loadFileNameList();
      this.togglePageLoader(false);
    },
  }
}
</script>
<style lang="scss" scoped>
.form_title {
  color: #235AA3;
  font-size: 24px;
  line-height: 35px;
  font-weight: bold;
  text-align: center;
}
</style>
